// 图片url加载后转成base64

export function imagesToBlobUrl(imageUrl) {
  return new Promise((reslove, reject) => {
    fetch(imageUrl, {
      mode: 'cors',
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch image: ${url}`);
        const blob = res.blob();
        return blob;
      })
      .then((blob) => {
        reslove(URL.createObjectURL(blob));
      });
  });
}

export function imagesToBase64OrBlob(imageUrls, isBlob) {
  return Promise.all(
    imageUrls.map((url) => {
      console.log('url', url);
      if (!url) {
        return Promise.resolve(undefined);
      }
      return fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(`Failed to fetch image: ${url}`);
          const blob = res.blob();

          return blob;
        })
        .then((blob) => {
          console.log('blob', URL.createObjectURL(blob));
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
              if (isBlob) {
                resolve(await imagesToBlobUrl(reader.result));
              } else {
                resolve(reader.result);
              }
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        });
    }),
  );
}

export async function imageToBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // Base64 字符串
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function toBase64(str) {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str); // Uint8Array
  let binary = '';
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary);
  // const jsonStr = JSON.stringify(obj);
  // const utf8Bytes = new TextEncoder().encode(jsonStr);
  // let binary = '';
  // utf8Bytes.forEach((b) => (binary += String.fromCharCode(b)));
  // return btoa(binary);
}

// base64转blob url
export function base64ToBlob(base64, mime = 'image/jpeg') {
  // 去掉 `data:mime/type;base64,` 前缀
  // const byteString = toBase64(base64.startsWith('data:image') ? base64.split(',')[1] : base64);
  // const ab = new ArrayBuffer(byteString.length);
  // const ia = new Uint8Array(ab);
  // for (let i = 0; i < byteString.length; i++) {
  //   ia[i] = byteString.charCodeAt(i);
  // }

  // const url = URL.createObjectURL(new Blob([ab], { type: mime }));
  // return url;
  const base64Data = base64.startsWith('data:image') ? base64.split(',')[1] : base64; // 去掉前缀
  return fetch(`data:${mime};base64,${base64Data}`)
    .then((res) => res.blob())
    .then((blob) => URL.createObjectURL(blob));
}

export function fileToBlobUrl(file) {
  return URL.createObjectURL(file);
}

export async function resizeImageBlobUrl(blobUrl, scale = 2) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // 避免跨域问题（如果 blob 来自远程）
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置新尺寸
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      // 绘制放大后的图片
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // 转成 Blob
      canvas.toBlob((blob) => {
        if (blob) {
          const newUrl = URL.createObjectURL(blob);
          resolve({ blob, url: newUrl });
        } else {
          reject(new Error('Canvas toBlob failed'));
        }
      }, 'image/png'); // 你也可以换成 "image/jpeg"
    };
    img.onerror = reject;
    img.src = blobUrl;
  });
}

export function getImageSize(file) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject('Not an image file');
      return;
    }

    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      });
      URL.revokeObjectURL(img.src); // 清理内存
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}
